/**
 * Include your custom JavaScript here.
 *
 * CRO: hide Loox floating Reviews tab on mobile product pages so ATC stays tappable.
 * Does not remove Loox reviews widgets / feed — only the side floating tab.
 */

(function () {
  function hideLooxFloatingOnMobileProduct() {
    try {
      if (!window.matchMedia || !window.matchMedia('(max-width: 640px)').matches) return;
      var isProduct =
        (window.theme && window.theme.pageType === 'product') ||
        (document.body && document.body.classList.contains('template-product'));
      if (!isProduct) return;

      var nodes = Array.prototype.slice.call(
        document.querySelectorAll(
          '#loox_floating_button, #looxFloatingButton, #looxReviewsTab, .loox-floating-btn, .loox-floating-widget'
        )
      );
      var all = document.querySelectorAll('[id*="loox"], [class*="loox"]');
      for (var j = 0; j < all.length; j++) {
        var el = all[j];
        var id = (el.id || '').toLowerCase();
        var cls = (typeof el.className === 'string' ? el.className : '').toLowerCase();
        if ((id.indexOf('float') !== -1 || cls.indexOf('float') !== -1) && nodes.indexOf(el) === -1) {
          nodes.push(el);
        }
      }
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].style.setProperty('display', 'none', 'important');
        nodes[i].style.setProperty('pointer-events', 'none', 'important');
        nodes[i].setAttribute('aria-hidden', 'true');
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideLooxFloatingOnMobileProduct);
  } else {
    hideLooxFloatingOnMobileProduct();
  }
  setTimeout(hideLooxFloatingOnMobileProduct, 800);
  setTimeout(hideLooxFloatingOnMobileProduct, 2000);
  setTimeout(hideLooxFloatingOnMobileProduct, 4000);
})();
